import React from "react";

import AlertsTemplate from "./AlertsTemplate";

const Closed = (props) => {
    return (
        <AlertsTemplate type={props.type} />
    )
}

export default Closed;